import React from "react";
import Colors from "../constants/Colors";

export const ThemeContext = React.createContext({
  darkMode: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggle: () => {},
  colors: Colors.light
});
